import {IMultiOccurrence, IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaire, IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemSautDeLigneClass} from "../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service";
import {IMonoOccurrence, IMonoOccurrenceOptions} from "../../../../../core/services/mono-occurrence.service";
import {IComponentController} from "angular";

interface IPageGs0071 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence,
    formulaireGal: IFormulaire;
    gapMultiOccurrenceOptions: IMultiOccurrenceOptions;
    gapMultiOccurrence: IMultiOccurrence;
    gppMultiOccurrenceOptions: IMultiOccurrenceOptions;
    menMultiOccurrenceOptions: IMultiOccurrenceOptions;
    fomMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Gs0071Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageGs0071 = this;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.formulaireGal = new Formulaire('LBL_BLC_GAL', [
            new FormulaireItem('vaegaltyp'),
            new FormulaireItem('galseqaff'),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('galsuj', {largeur: 50}),
            new FormulaireItem('galtxt', {largeur: 100})
        ], {largeurDefaut: 25});

        vm.gapMultiOccurrenceOptions = {
            bloc: 'gap',
            colonnesVisibles: [
                {nom: 'gapdathredeb', largeur: 170},
                {nom: 'gapdathrefin', largeur: 170},
                {nom: 'gapflgsof', largeur: 170},
                {nom: 'gapflgsow', largeur: 170},
                {nom: 'gapflgemp', largeur: 170},
                {nom: 'gapflgpei', largeur: 170}
            ],
            formulaire: new Formulaire([
                new FormulaireItem('gapdatdeb', { largeur: 50 }),
                new FormulaireItem('gapdatfin', { largeur: 50 }),
                new FormulaireItem('gapflgsof'),
                new FormulaireItem('gapflgsow'),
                new FormulaireItem('gapflgemp'),
                new FormulaireItem('gapflgpei'),
                
            ], {largeurDefaut: 20})
        };

        vm.gppMultiOccurrenceOptions = {
            bloc: 'gpp',
            colonnesVisibles: [
                {nom: 'pradsc', largeur: 200},
                {nom: 'pradscmnu', largeur: 300},
                {nom: 'vaesysapp_dsc', largeur: 180},
                {nom: 'nbrusagers', largeur: 130}
            ],
            formulaire: new Formulaire([
                new FormulaireItem('pracleint', {
                    required: true,
                    largeur: 25,
                    resourceParams: (data: any) => ({
                        vaesysapp: 'SOF2,EMP2',
                        praflgemp: 0,
                        gapflgsof: data.$ancetre.gapflgsof,
                        gapflgemp: data.$ancetre.gapflgemp,
                        gapflgsow: data.$ancetre.gapflgsow,
                        gapflgpei: data.$ancetre.gapflgpei,
                        gapflgaux: data.$ancetre.gapflgaux
                    })
                }),
                new FormulaireItem('pradscmnu', { largeur: 25, readonly: true }),
                new FormulaireItem('vaesysapp_dsc', { largeur: 25, readonly: true }),
                new FormulaireItem('nbrusagers', { largeur: 25, readonly: true })
            ], {largeurDefaut: 25})
        };
    }
}
